<template>
  <div class="f-v f-ast">
    <donut-modal-sections-title :title="title" category="warn" />
    <div v-if="modal.data?.phase === 'warning'" class="t m-bx3">
      You've been inactive for a while. For your security, you'll be signed out soon unless you confirm you're still here.
    </div>
    <div v-else class="t m-bx3">
      You were signed out after extended period of inactivity. Please sign in again to continue.
    </div>
    <div class="f-ac f-je">
      <donut-form ref="signOutForm" method="delete" action="/users/sign_out">
        <a class="button inv m-r" @click="signOut">Sign out</a>
      </donut-form>
      <button
        v-if="modal.data?.phase === 'warning'"
        class="button"
        :class="{ loading: touching }"
        @click="stillHere"
      >Still here</button>
    </div>
  </div>
</template>

<script setup>
  import { ref, computed } from 'vue';
  import { useStore } from 'vuex';

  const { state, dispatch } = useStore();

  const modal = computed(() => state.modal);

  // modal.data briefly becomes null as this component is unmounting (closeModal resets it to
  // defaults in the same reactive flush that flips modal.visible, which is what actually causes
  // the parent container to stop rendering this component) -- guard against that transient state.
  const title = computed(() => (modal.value.data?.phase === 'warning' ? 'Still there?' : 'Session expired'));

  const signOutForm = ref(null);
  const signOut = () => { signOutForm.value.submit(); };

  const touching = ref(false);
  const stillHere = async () => {
    touching.value = true;
    await dispatch('keepSessionAlive');
    touching.value = false;
  };
</script>
